import { ReactNode, useEffect, useRef, useState } from "react";
import classNames from "classnames";

import useScrollDirection from "@/hooks/useScrollDirection";

type Props = {
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
  defaultHeight?: string | number;
};

const ExposeOnScroll: React.FC<Props> = ({
  children,
  className,
  disabled,
  defaultHeight = "100%",
}) => {
  const { direction } = useScrollDirection({ disabled });
  const [height, setHeight] = useState<string | number>(defaultHeight);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current || disabled) {
      return;
    }
    const newHeight = direction !== "down" ? defaultHeight : 0;
    setHeight(newHeight);
  }, [direction, ref.current, disabled, defaultHeight]);

  return disabled ? (
    <>{children}</>
  ) : (
    <div
      className={classNames(
        "duration-200 ease-in-out overflow-hidden",
        className,
      )}
      style={{
        height,
      }}
      ref={ref}
      data-testid="expose-on-scroll"
      aria-hidden={direction === "down"}
    >
      {children}
    </div>
  );
};

export default ExposeOnScroll;
